import { render, staticRenderFns } from "./DispensaPacienteAdm.vue?vue&type=template&id=65194f11"
import script from "./DispensaPacienteAdm.vue?vue&type=script&lang=js"
export * from "./DispensaPacienteAdm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports